const baseUrl = 'lovedone';

export const LovedOneApi = {
  lovedOne: `${baseUrl}`,
  contact: (id: string) => `${baseUrl}/${id}/contact`,
  address: (id: string) => `${baseUrl}/${id}/address`
};
